"use client";

import { graphql, readFragment, useQuery } from "@opensea/graphql";
import { FlexCenter, FlexColumn, Separator, TextHeading, TooltipLabel } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { PreviewTooltipContent } from "@/components/tooltip/PreviewTooltip";
import { ItemMedia } from "../ItemMedia/ItemMedia";
import { ItemMediaFragment } from "../ItemMedia/ItemMedia.fragment";
import { ItemMetadataChips } from "../item-page/ItemMetadataChips";
import { ItemMetadataChipsFragment } from "../item-page/ItemMetadataChips/ItemMetadataChips.fragment";
import { itemIdentifier } from "../utils";
import { ItemPreviewTooltipContentFragment } from "./ItemPreviewTooltipContent.fragment";
import { ItemPreviewTooltipContentSkeleton } from "./ItemPreviewTooltipContentSkeleton";
import { ItemPreviewTooltipTraitTable } from "./TraitTable/ItemPreviewTooltipTraitTable";
import { ItemPreviewTooltipTraitTableFragment } from "./TraitTable/ItemPreviewTooltipTraitTable.fragment";
const query = graphql(`
    query ItemPreviewTooltipContentQuery($identifier: ItemIdentifierInput!) {
      itemByIdentifier(identifier: $identifier) {
        __typename
        ... on Item {
          id
          name
          imageUrl
          attributes {
            __typename
          }
          ...ItemMedia
          ...ItemMetadataChips
          ...ItemPreviewTooltipTraitTable
        }
      }
    }
  `, [ItemMediaFragment, ItemMetadataChipsFragment, ItemPreviewTooltipTraitTableFragment]);
export const ItemPreviewTooltipContent = withSuspense(function ItemPreviewTooltipContent({
  item: itemKey
}) {
  const identifier = readFragment(ItemPreviewTooltipContentFragment, itemKey);
  const t = useTranslations("ItemPreviewTooltipContent");
  const [{
    data
  }] = useQuery({
    query,
    variables: {
      identifier: itemIdentifier(identifier)
    }
  });
  const item = data?.itemByIdentifier;
  if (item?.__typename === "Item") {
    const attributes = item.attributes;
    return <PreviewTooltipContent className="gap-3">
          {item.imageUrl ? <FlexCenter className="w-[200px] shrink-0">
              <ItemMedia containerSize={200} interactive={false} item={item} surfaceOverrides={{
          "3d": "preview",
          html: "preview"
        }} />
            </FlexCenter> : null}
          <FlexColumn className="min-w-[300px]">
            <FlexColumn className="gap-1">
              <TextHeading size="xs">{item.name}</TextHeading>
              <ItemMetadataChips chips={["top_offer", "rarity"]} item={item} />
            </FlexColumn>
            {(attributes?.length || 0) > 0 && <>
                <Separator className="my-2" />
                <ItemPreviewTooltipTraitTable item={item} />
              </>}
          </FlexColumn>
        </PreviewTooltipContent>;
  }
  return <PreviewTooltipContent>
        <TooltipLabel>{t("error")}</TooltipLabel>
      </PreviewTooltipContent>;
}, {
  fallback: <ItemPreviewTooltipContentSkeleton />
});